<pds-module-header title="Regiões" ctaLabel="Nova região" [ctaOnClick]="onClickCreateRegion.bind(this)">
  <pds-new-breadcrumb [items]="breadcrumbItems"></pds-new-breadcrumb>

  <pds-panel>
    <pds-form [formGroup]="searchForm">
      <pds-form-row grid="1-1-1">
        <pds-form-field label="Busca">
          <input type="text" formControlName="search" placeholder="Pesquise por descrição" />
        </pds-form-field>

        <pds-form-field label="Origem">
          <input type="text" formControlName="startZipCode" placeholder="CEP origem" />
        </pds-form-field>

        <pds-form-field label="Destino">
          <input type="text" formControlName="endZipCode" placeholder="CEP destino" />
        </pds-form-field>
      </pds-form-row>

      <pds-form-actions>
        <button pdsButton="primary" modifier="outlined" type="button" (click)="clearFilters()" [disabled]="searchForm.pristine">Limpar filtros</button>
        <button pdsButton type="button" (click)="onSubmitSearch()">Buscar</button>
      </pds-form-actions>
    </pds-form>
  </pds-panel>

  <ng-container *ngIf="regionsState.data?.items?.length">
    <pds-table>
      <table>
        <thead>
          <tr>
            <th>Descrição</th>
            <th>CEP origem</th>
            <th>CEP destino</th>
            <th pdsColActions>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let region of regionsState.data?.items">
            <td>{{ region.description }}</td>
            <td>{{ region.originZipCode }}</td>
            <td>{{ region.destinationZipCode }}</td>
            <td pdsColActions>
              <button pdsButton="icon" modifier="outlined" title="Detalhes" (click)="onClickDetails(region)">
                <span class="icon">visibility</span>
              </button>
              <button pdsButton="icon" modifier="outlined" title="Remover" (click)="onClickDelete(region)">
                <span class="icon">delete</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </pds-table>
  </ng-container>

  <ng-container *ngIf="regionsState.data && !regionsState.data.items.length">
    <strong>Nenhuma região encontrada.</strong>
  </ng-container>

  <ng-container *ngIf="regionsState.failure">
    <pds-alert type="error" title="Erro ao carregar regiões">Tente novamente em instantes.</pds-alert>
  </ng-container>

  <pds-pagination [pagination]="pagination$" (paginate)="onPaginate($event)"></pds-pagination>

  <peca-region-modal-form #regionModal (created)="onRegionCreated()"></peca-region-modal-form>
</pds-module-header>
